import { z } from 'zod'

import { AttendeeMatchState } from '../constants/attendee'
import { MembershipLevelValue } from '../constants/membership'
import { GenderType } from '../constants/gender'
import { InventoryType } from '../constants/inventory'
import { dbEntitySchema } from './system'

export const AttendeeMatchSchema = dbEntitySchema.extend({
  attendee: z.string(),
  matchedAttendee: z.string(),
  state: z.nativeEnum(AttendeeMatchState),
  priority: z.number(),
  firstName: z.string(),
  name: z.string(),
  title: z.string(),
  imageUrl: z.string(),
  user: z.string(),
  matchedUser: z.string(),
  event: z.string().nullable(),
  venue: z.string(),
  date: z.date(),
  inventoryType: z.nativeEnum(InventoryType),
  membershipLevel: z.nativeEnum(MembershipLevelValue),
  gender: z.nativeEnum(GenderType),
})
